import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.css'],
})
export class AddVehicleComponent {
  @Input() vehicleDetail: any;
  @Input() isAddFromAppointment:boolean = false;
  constructor(
    private activeModal: NgbActiveModal
  ) {}
  OnClose() {
    this.activeModal.close({ success: false });
  }
}
